var MultilevelCustomFieldValueBuilder = /** @class */ (function () {
    function MultilevelCustomFieldValueBuilder() {
        this.levelValue = {
            value: '',
            children: [],
            disabled: false,
            translatedValues: {}
        };
    }
    MultilevelCustomFieldValueBuilder.prototype.withValue = function (value) {
        this.levelValue.value = value;
        return this;
    };
    MultilevelCustomFieldValueBuilder.prototype.withChildren = function (children) {
        this.levelValue.children = children;
        return this;
    };
    MultilevelCustomFieldValueBuilder.prototype.withDisabled = function (isDisabled) {
        this.levelValue.disabled = isDisabled;
        return this;
    };
    MultilevelCustomFieldValueBuilder.prototype.withtranslatedValues = function (translatedValues) {
        this.levelValue.translatedValues = translatedValues;
        return this;
    };
    MultilevelCustomFieldValueBuilder.prototype.build = function () {
        return this.levelValue;
    };
    return MultilevelCustomFieldValueBuilder;
}());
export { MultilevelCustomFieldValueBuilder };
//# sourceMappingURL=multilevel-custom-field-value.builder.js.map